import './jquery';
import ComponentsHandler from '../_common/ComponentsHandler';
import Accordion from '../_common/components/Accordion';
import ConditionalVisibility from '../_common/components/ConditionalVisibility';
import InView from '../_common/components/InView';
import Lovers from '../_common/components/Lovers';
import Navigation from '../_common/components/Navigation';
import Select from '../_common/components/Select';
import Shapes from '../_common/components/Shapes';
import Toggle from '../_common/components/Toggle';

window.componentHandler = new ComponentsHandler({
	Accordion,
	ConditionalVisibility,
	InView,
	Lovers,
	Navigation,
	Select,
	Shapes,
	Toggle,
});
